export const npcData = [


  {"title": "d264 Surname", "id":"dxsurname", "roll":[
    "Baldhelmson", "Alddino", "Acargrim", "Anlay", "Ardan", "Beornhildi", "Berlen", "Bethly", "Blackarrow", "Bri", "Brightpike", "Brisyl", "Autumnridge", "Acarbri", "Alddra", "Aldloc", "Aldnehere", "Andja", "Andsean", "Bladekeep", "Bladerock", "Bladeweaver", "Blazebloom", "Bonesky", "Brand", "Axetail", "Burninggrip", "Canmuel", "Carsung", "Casegar", "Chardloc", "Chared", "Charjeffwise", "Charla", "Charto", "Chelllay", "Chestbreath", "Clabri", "Clawtaker", "Coldhelm", "Coldsorrow", "Conhol", "Crestbough", "Crestflame", "Cuthacar", "Darkwatcher", "Darkwoods", "Da'roc", "Dawnwolf", "Dicgifu", "Distantmaw", "Docald", "Docbryt", "Dodan", "Dodand", "Dohelm", "Doomkeep", "Dragonore", "Dunto", "Duskflow", "Duskgrip", "Dusktalon", "Duststalker", "Eadliamgeor", "Eagleeye", "Eaglewalker", "Earthmane", "Eddan", "Emberrun", "Escceol", "Escthony", "Fallensword", "Farkeeper", "Ferdsara", "Fernriver", "Ferthesc", "Firewalker", "Flamecrag", "Flatkeeper", "Flatroar", "Forestdown", "Fourcrag", "Fourstrength", "Fredferret", "Frithbrand", "Frozenspire", "Fusereaper", "Fusewatcher", "Gali", "Garfer", "Glowbane", "Glowhell", "Glowmight", "Goreswift", "Graypunch", "Greatbash", "Greatbender", "Greatmane", "Greenbloom", "Grizzlymantle", "Ha", "Halald", "Hallowtide", "Hammerflare", "Haro", "Hazescar", "Heavyflower", "Helllance", "Helmruth", "Hereann", "Heremit", "Heslaf", "Highdane", "Humblebringer", "Icegleam", "Ironleaf", "Jalac", "Jeffthas", "Johnmar", "Kevald", "Laftim", "Las", "Lerol", "Lescy", "Lightflaw", "Lightningrage", "Linley", "Locea", "Lybando", "Mannni", "Manphia", "Marma", "Mastermourn", "Meadowflow", "Meadowspark", "Meadowspirit", "Mericrow", "Mesty", "Mildmore", "Mirthtree", "Mit", "Monsterblower", "Monstervigor", "Moonbend", "Morningcloud", "Mosscutter", "Mountainoak", "Mourningeyes", "Mourninghelm", "Nake", "Netherblaze", "Ni", "Nielcuth", "Niswith", "Noblebrace", "Noblesinger", "Nosebranch", "Oatdream", "Oceanglade", "Oceansteam", "Orbsong", "Orbsurge", "Ordlee", "Oson", "Palebreaker", "Peaceroar", "Perie", "Phiedoc", "Phoenixgrip", "Phoenixmantle", "Pineorb", "Pineswift", "Plainward", "Pridedraft", "Proudbraid", "Proudsky", "Redreaper", "Redward", "Regalgleam", "Reginferum", "Retcas", "Robgard", "Robhes", "Rochol", "Rockcut", "Rockshaper", "Roseheart", "Roughswift", "Ry", "Sacredlight", "Samac", "Sammes", "Sararie", "Saro", "Saurbreeze", "Saurmaul", "Saurwhirl", "Seamourn", "Shadowpelt", "Sharpweaver", "Shieldkiller", "Silentchewer", "Singleforce", "Smartmantle", "Softridge", "Sonead", "Sonter", "Spiritbash", "Spiritkeep", "Spiritshade", "Spiritsorrow", "Spiritstrike", "Springaxe", "Springmight", "Starcut", "Stardraft", "Stargrip", "Starwoods", "Steelcut", "Steelfist", "Stelee", "Stoneblood", "Stonesteel", "Stonewolf", "Stoutstrength", "Summerdoom", "Sunflayer", "Sung", "Tallbrand", "Talldraft", "Tallwhisper", "Thasthor", "Thonytine", "Threebringer", "Thunderkiller", "Titangem", "Titanhorn", "Tolelf", "Tomdod", "Tommac", "Tori", "Treebreeze", "Trieli", "Umi", "Usan", "Venmeri", "Vidrid", "Voidripper", "Wardbur", "Warforge", "Wen", "Werdmit", "Whitecloud", "Whitfist", "Wildryt", "Winterspark", "Wiseethel", "Wiseflower", "Wisegard", "Woodenfall", "Youngblood", "Zachard", "Zadino", "Zapa",
  ]},
  
  {"title": "d986 First Name", "id":"dxfirstname", "roll":[
    "Aldren", "Ackmard", "Achard", "Aidan", "Airis", "Allso", "Amerdan", "Anfar", "Anumi", "Ault", "Ayrie", "Bacohl", "Albright", "Aboloft", "Aerden", "Afflon", "Agnar", "Ahalfar", "Ahdun", "Asden", "Asdern", "Aslan", "Atar", "Atlin", "Auchfor", "Alderman", "Badeek", "Baduk", "Balati", "Baradeer", "Barkydle", "Basden", "Bayde", "Beck", "Bedic", "Beeron", "Bein", "Beson", "Besur", "Besurlde", "Bewul", "Biedgar", "Bildon", "Biston", "Bithon", "Boal", "Boaldelr", "Bolrock", "Brakdern", "Breanon", "Bredere", "Bredin", "Bredock", "Breen", "Brighton", "Bristan", "Buchmeid", "Bue", "Busma", "Buthomar", "Bydern", "Caelholdt", "Cainon", "Calden", "Camchak", "Camilde", "Cardon", "Casden", "Cayold", "Celbahr", "Celorn", "Celthric", "Cerdern", "Cespar", "Cether", "Cevelt", "Chamon", "Chesmarn", "Chidak", "Cibrock", "Cipyar", "Ciroc", "Codern", "Colthan", "Connell", "Cordale", "Cos", "Cosdeer", "Cuparun", "Cusmirk", "Cydare", "Cylmar", "Cythnar", "Cyton", "Daburn", "Daermod", "Dak", "Dakamon", "Dakkone", "Dalburn", "Dalmarn", "Dapvhir", "Darkboon", "Darkkon", "Darkspur", "Darmor", "Darpick", "Dasbeck", "Dask", "Deathmar", "Defearon", "Derik", "Derrin", "Desil", "Dessfar", "Dinfar", "Dismer", "Doceon", "Dochrohan", "Dokoran", "Dorn", "Dosoman", "Drakoe", "Drakone", "Drandon", "Drit", "Drophar", "Dryden", "Dryn", "Duba", "Dukran", "Durmark", "Dusaro", "Dyfar", "Dyten", "Eard", "Eckard", "Efamar", "Efar", "Egmardern", "Eiridan", "Ekgamut", "Elik", "Elson", "Elthin", "Enbane", "Endor", "Enidin", "Enoon", "Enro", "Erikarn", "Erim", "Eritai", "Escariet", "Espardo", "Etar", "Etburn", "Etdar", "Ethen", "Etmere", "Etran", "Eythil", "Faoturk", "Faowind", "Fearlock", "Fetmar", "Feturn", "Ficadon", "Fildon", "Firedorn", "Firiro", "Floran", "Folmard", "Fraderk", "Fronar", "Fydar", "Fyn", "Gafolern", "Gai", "Galain", "Galiron", "Gametris", "Gauthus", "Gemardt", "Gemedern", "Gemedes", "Gerirr", "Geth", "Gib", "Gibolock", "Gibolt", "Gith", "Gosford", "Gothar", "Gothikar", "Gresforn", "Grimie", "Gryn", "Gundir", "Gustov", "Guthale", "Gybol", "Gybrush", "Gyin", "Halmar", "Harrenhal", "Hasten", "Hecton", "Heramon", "Hermenze", "Hermuck", "Hezak", "Hildale", "Hildar", "Hileict", "Hydale", "Hyten", "Iarmod", "Idon", "Ieli", "Ieserk", "Ikar", "Ilgenar", "Illilorn", "Ingel", "Ipedorn", "Irefist", "Ironmark", "Isen", "Isil", "Ithric", "Jalil", "Jamik", "Janus", "Jayco", "Jaython", "Jesco", "Jespar", "Jethil", "Jex", "Jib", "Jibar", "Jin", "Juktar", "Julthor", "Jun", "Justal", "Kafar", "Kellan", "Keran", "Kesad", "Kesmon", "Kethren", "Kib", "Kibidon", "Kilburn", "Kildarien", "Kimdar", "Kinorn", "Kip", "Kirder", "Kodof", "Kolmorn", "Kyrad", "Lackus", "Lacspor", "Laderic", "Lafornon", "Lahorn", "Laracal", "Ledale", "Leit", "Lephar", "Lephidiles", "Lerin", "Lesphares", "Letor", "Lidorn", "Lin", "Liphanes", "Loban", "Lox", "Ludokrin", "Luphildern", "Lupin", "Macon", "Madarlon", "Mafar", "Marderdeen", "Mardin", "Markard", "Markdoon", "Marklin", "Mashasen", "Mathar", "Medarin", "Meowol", "Merdon", "Meridan", "Merkesh", "Mes'ard", "Mesophan", "Mesoton", "Mezo", "Michael", "Mick", "Mickal", "Migorn", "Milo", "Miphates", "Mi'talrythin", "Mitar", "Modric", "Modum", "Mudon", "Mufar", "Mujarin", "Mylo", "Mythik", "Mythil", "Nadeer", "Nalfar", "Namorn", "Naphates", "Neowyld", "Nidale", "Nikpal", "Nikrolin", "Niktohal", "Niro", "Noford", "Nothar", "Nuthor", "Nuwolf", "Nydale", "Nythil", "O’tho", "Ocarin", "Occelot", "Occhi", "Odaren", "Odeir", "Ohethlic", "Okar", "Omaniron", "Omarn", "Orin", "Ospar", "Othelen", "Palid", "Papur", "Peitar", "Pelphides", "Pender", "Pendus", "Perder", "Perol", "Phairdon", "Phemedes", "Phexides", "Phoenix", "Picon", "Pictal", "Picumar", "Pildoor", "Pixdale", "Ponith", "Poran", "Poscidion", "Puthor", "Pyder", "Qeisan", "Qidan", "Quiad", "Quid", "Quiss", "Qupar", "Qysan", "Radag'mal", "Randar", "Raysdan", "Rayth", "Reaper", "Resboron", "Reth", "Rethik", "Rhithik", "Rhithin", "Rhysling", "Riandur", "Rikar", "Rismak", "Riss", "Ritic", "Rogeir", "Rogist", "Rogoth", "Rophan", "Rulrindale", "Ryfar", "Ryfar", "Ryodan", "Rysdan", "Rythen", "Rythern", "Sabal", "Sadareen", "Safilix", "Samon", "Samot", "Sasic", "Scoth", "Secor", "Sed", "Sedar", "Senick", "Senthyril", "Serin", "Sermak", "Seryth", "Sesmidat", "Seth", "Setlo", "Shade", "Shadowbane", "Shane", "Shard", "Shardo", "Shillen", "Silco", "Sildo", "Sil'forrin", "Silpal", "Sithik", "Soderman", "Sothale", "Staph", "Stenwulf", "Steven", "Suktor", "Suth", "Sutlin", "Syr", "Syth", "Sythril", "Talberon", "Telpur", "Temilfist", "Tempist", "Teslanar", "Tespar", "Tessino", "Tethran", "Thiltran", "Tholan", "Tibers", "Tibolt", "Ticharol", "Tilner", "Tithan", "Tobale", "Tol’Solie", "Tolle", "Tolsar", "Toma", "Tothale", "Tousba", "Towerlock", "Tuk", "Tuscanar", "Tusdar", "Tyden", "Uerthe", "Ugmar", "Uhrd", "Undin", "Updar", "Uther", "Vaccon", "Vacone", "Valkeri", "Valynard", "Vectomon", "Veldahar", "Vespar", "Vethelot", "Victor", "Vider", "Vigoth", "Vilan", "Vildar", "Vinald", "Vinkolt", "Virde", "Voltain", "Volux", "Voudim", "Vythethi", "Wak’dern", "Walkar", "Wanar", "Wekmar", "Werymn", "Weshin", "William", "Willican", "Wilte", "Wiltmar", "Wishane", "Witfar", "Wrathran", "Wraythe", "Wuthmon", "Wyder", "Wyeth", "Wyvorn", "Xander", "Xavier", "Xenil", "Xex", "Xithyl", "Xuio", "Y’reth", "Yabaro", "Yepal", "Yesirn", "Yssik", "Yssith", "Zak", "Zakarn", "Zecane", "Zeke", "Zerin", "Zessfar", "Zidar", "Zigmal", "Zile", "Zilocke", "Zio", "Zoru", "Zotar", "Zutar", "Zyten", "Aiko", "Adlanniel", "Adanessa", "Aesuithiel", "Aethelu", "Ailith", "Ailith", "Airedhiel", "Aistaraina", "Algrima", "Alvar", "Alvar", "Aethelu", "Adanessa", "Adlanniel", "Adlanniel", "Adonnenniel", "Adva", "Aelflaed", "Aithne", "Alditha", "Aldyth", "Aldyth", "Alfreda", "Algrima", "Aethelu", "Alvina", "Amice", "Amity", "Amity", "Amity", "Anameleth", "Annis", "Arethusa", "Argrama", "Argrama", "Arietta", "Armida", "Arquenniel", "Arwen", "Ashton", "Ashton", "Avellana", "Avery", "Balthilda", "Balthilda", "Balthilda", "Baragyth", "Bardina", "Barina", "Batilda", "Batilda", "Beba", "Beda", "Bega", "Bega", "Beriadhwen", "Beverly", "Beverly", "Biba", "Bibda", "Bliss", "Bliss", "Bliss", "Blossom", "Bobda", "Boffina", "Bologrika", "Bologrika", "Breena", "Breena", "Brenna", "Brighton", "Brighton", "Brodhika", "Bronneth", "Bronneth", "Brooke", "Brucie", "Brucie", "Brucie", "Bugdahra", "Bulla", "Caladwen", "Caladwen", "Cerina", "Cerina", "Charlene", "Charlene", "Chelsey", "Chelsey", "Chelsi", "Chelsi", "Chelsie", "Cyneburga", "Cyneburga", "Daisy", "Dammina", "Dana", "Dayna", "Deana", "Deana", "Deana", "Deana", "Dedina", "Derina", "Dimgola", "Dimzada", "Dimzada", "Dorra", "Drumnia", "Drumnia", "Duloorzal", "Dumalba", "Dumina", "Durina", "Durzalka", "Durzuba", "Earline", "Edgarda", "Edgarda", "Edgarda", "Edhelwen", "Editta", "Editta", "Edmonda", "Edwina", "Edwina", "Elfreda", "Elfreda", "Elfrida", "Elfriede", "Emerson", "Emerson", "Emerson", "Emerson", "Emerson", "Emersyn", "Eruraina", "Eruraviel", "Estelwen", "Etel", "Ethel", "Fae", "Fae", "Fay", "Fay", "Fay", "Fay", "Fays", "Fays", "Fays", "Figa", "Figda", "Figina", "Figina", "Frada", "Frada", "Fraga", "Frega", "Frega", "Frela", "Frelina", "Frepina", "Frudina", "Fubda", "Gadrina", "Garinyth", "Gavina", "Geba", "Geba", "Gerina", "Ghamobal", "Glashikha", "Gorinyth", "Gormana", "Gotrekyth", "Gratuba", "Grimnira", "Grodrika", "Grumda", "Grumda", "Grunlyn", "Gundrika", "Gwaedhiel", "Gwaedhiel", "Haakona", "Hadrina", "Hadrina", "Hailee", "Hailee", "Hailey", "Hailie", "Hailie", "Haleigh", "Haleigh", "Haley", "Haley", "Haley", "Haley", "Hali", "Hali", "Hali", "Halle", "Harley", "Haven", "Haven", "Haven", "Hayleigh", "Hayley", "Hayley", "Haylie", "Henaradwen", "Herenya", "Hildra", "Ithilwen", "Jevena", "Justice", "Justice", "Kana", "Keegana", "Keegana", "Kelcie", "Kelcie", "Kelsea", "Kelsea", "Kelsea", "Kelsea", "Kelsea", "Kelsey", "Kelsi", "Kelsi", "Kelsie", "Kelsie", "Kendal", "Kendall", "Kendall", "Kendall", "Kendyl", "Kevana", "Khurgokha", "Kiara", "Kiara", "Kierna", "Kim", "Kim", "Kimber", "Kimberly", "Kimberly", "Kyndall", "Kyndall", "Lee", "Lee", "Lee", "Leigh", "Leigha", "Leigha", "Leigha", "Leigha", "Leighton", "Leighton", "Lili", "Lili", "Lili", "Lili", "Lili", "Lilian", "Liliana", "Liliana", "Liliane", "Liliane", "Liliane", "Liliane", "Liliane", "Liliane", "Lilianna", "Lilianna", "Lilien", "Lilien", "Lillian", "Lilliana", "Lilliana", "Lilliana", "Lilliana", "Lilliana", "Lilyana", "Lilyanna", "Lilyanna", "Lilyanna", "Limbairedhiel", "Limbairedhiel", "Lindariel", "Lindsay", "Lindsay", "Lindsay", "Lindsey", "Lokra", "Lugrakal", "Lugrakal", "Lunna", "Lyndsey", "Lyndsey", "Lyndsey", "Lynsey", "Lynsey", "Lynsey", "Maci", "Maci", "Maci", "Maci", "Macie", "Macy", "Macy", "Maerwen", "Magnunda", "Maleah", "Marlee", "Marleigh", "Mashakha", "Meadow", "Meadow", "Meadow", "Meldamiriel", "Meldamiriel", "Menelwen", "Mentathiel", "Mildred", "Miluiel", "Minuialwen", "Miriel", "Mundra", "Murkabal", "Muzgarkal", "Narashal", "Nelle", "Nellethiel", "Nellethiel", "Nellie", "Nelly", "Nelly", "Nelly", "Nostariel", "Oda", "Odina", "Odina", "Ogrunal", "Oklyn", "Olina", "Olumbumal", "Paityn", "Paityn", "Payten", "Payton", "Payton", "Peda", "Pendecardiel", "Peyton", "Peyton", "Pida", "Piera", "Piera", "Posy", "Presley", "Ragna", "Ragna", "Raina", "Raina", "Ranulyn", "Rareka", "Riley", "Riley", "Rogdulumal", "Rohesia", "Rohesia", "Rordana", "Roreka", "Rovena", "Rowan", "Rowena", "Rowena", "Rylan", "Rylan", "Rylan", "Ryleigh", "Ryleigh", "Rylie", "Rylie", "Rylie", "Rylie", "Scarlet", "Scarlett", "Scarlett", "Shakhal", "Shamarkha", "Shelley", "Shelly", "Shelly", "Shirley", "Shulumal", "Shutumal", "Sigrid", "Skaga", "Skaga", "Skallyn", "Skallyn", "Snatasha", "Snatasha", "Solita", "Somana", "Sunniva", "Sunniva", "Synne", "Tatum", "Tauredhiel", "Tauredhiel", "Tedina", "Tedina", "Tharwaithiel", "Thingryd", "Thorlekyth", "Tiba", "Todina", "Toga", "Togina", "Torka", "Tosina", "Ulrika", "Urzarkha", "Ushumal", "Valaina", "Valaina", "Valisilwen", "Vendethiel", "Verya", "Whitley", "Whitney", "Whitney", "Whitney", "Whitney", "Yargarkha", "Yombal", "Zowana", "Zowana",
  ]},  

  {"title": "d479 Personality", "id":"dxpersonality", "roll":[
    "Rude and Sharp", "Unforgiving and Verbose", "Charmer and Judgmental", "Tempermental and Cheerful", "Boring and Assertive", "Boisterous and Lazy", "Intimidating and Temperate", "Dishonest and Loves Beer", "Irritating and Spoiled", "Stubborn and Nimble", "Jaded and Brilliant", "Insincere and Immodest", "Intuitive and Spunky", "Alcoholic and Quiet", "Cruel and Empathic", "Picks nose and Eccentric", "Inventive and Combative", "Sadistic and Intuitive", "Bratty and Judgmental", "Virtuous and Empathic", "Selfish and Rude", "Cheerful and Graceful", "Ugly and Plain", "Argumentative and Tired", "Ignorant and Tactful", "Sneaky and Gloomy", "Reflective and Classy", "Studious and Miserly", "Cheerless and Combative", "Reserved and Studious", "Tattooed and Debonair", "Good Gambler and Charismatic", "Touchy and Naive", "Gloomy and Irritable", "Sheepish and Secretive", "Frank and Loves Beer", "Ignorant and Empathic", "Sagely and Wise", "Creepy and Shy", "Abrasive and Silent", "Sensitive and Temperate", "Eccentric and Focused", "Smooth and Argumentative", "Strong and Intimidating", "Loud and Succinct", "Timid and Tired", "Obnoxious and Charismatic", "Alert and Thorough", "Shrewd and Simple", "Insincere and Obnoxious", "Brutish and Fearful", "Clever and Dull", "Gloomy and Assertive", "Self-Centered and Poor", "Brash and Con man", "Emotional and Jealous", "Sharp and Eloquent", "Dependable and Filthy mouth", "Smooth and Sour", "Picks nose and Calm", "Uncooperative and Reflective", "Sour and Considerate", "Snob and Tenacious", "Audacious and Tenacious", "Virtuous and Shallow", "Ugly and Innocent", "Sensitive and Suave", "Judgmental and Trustworthy", "Thoughtful and Scruffy", "Sly and Scruffy", "Tempermental and Courteous", "Judgmental and Suave", "Respectful and Curious", "Rude and Evasive", "Cynical and Carefree", "Eloquent and Fanatical", "Unhappy and Sneaky", "Artistic and Bratty", "Tired and Aloof", "Well-informed and Tactful", "Evasive and Poor", "Sheepish and Reflective", "Unhappy and Nosy", "Sour and Fearful", "Abrasive and Disrespectful", "Empathic and Introverted", "Determined and Snob", "Loyal and Aloof", "Brash and Verbose", "Audacious and Alert", "Careful and Intuitive", "Carefree and Honest", "Brutish and Gullible", "Beautiful and Educated", "Sarcastic and Dumb", "Refined and Rude", "Loud and Tactful", "Debonair and Cranky", "Haughty and Crabby", "Cranky and Strong", "Rude and Emotional", "Intolerant and Angry", "Scruffy and Helpful", "Energetic and Pleasant", "Evasive and Cheerful", "Messy and Cheerful", "Courteous and Know-it-all", "Opinionated and Strong", "Fearful and Nosy", "Bashful and Alert", "Cruel and Shrewd", "Timid and Reliable", "Strange and Loves Beer", "Poor Gambler and Unfriendly", "Upbeat and Immodest", "Humble and Disrespectful", "Shrewd and Con man", "Inquisitive and Withdrawn", "Immature and Friendly", "Charismatic and Incoherent", "Religious and Discreet", "Reflective and Debonair", "Uncooperative and Reserved", "Reckless and Tall", "Cynical and Shallow", "Withdrawn and Unfriendly", "Educated and Nimble", "Secretive and Fanatical", "Cranky and Patient", "Self-Centered and Trusting", "Sleazy and Story-teller", "Sheepish and Humble", "Immodest and Sarcastic", "Educated and Irritating", "Lazy and Bites Nails", "Dishonest and Patient", "Empathic and Smooth", "Immature and Creepy", "Cheerless and Con man", "Good-looking and Determined", "Evasive and Paranoid", "Beautiful and Spunky", "Reserved and Charmer", "Eloquent and Boring", "Brilliant and Studious", "Intimidating and Belligerent", "Sullen and irresponsible", "Deceitful and Loud", "Hot-headed and Virtuous", "Sagely and Contrarian", "Intimidating and Tattooed", "Humorous and Solitary", "Refined and Rude", "Overweight and Argumentative", "Fanatical and Kleptomaniac", "Thorough and Unfriendly", "Cranky and Creepy", "Simple and Clean", "Studious and Talkative", "Sincere and Perfectionist", "Obese and Sneaky", "Honest and Story-teller", "Picks nose and Easygoing", "Timid and Reserved", "Bashful and Immodest", "Immodest and Virtuous", "Sagely and Self-Centered", "Dishonest and Tempermental", "Argumentative and Sagely", "Sarcastic and Cranky", "Frank and Jaded", "Reliable and Self-Centered", "Intimidating and Disrespectful", "Strong and Reluctant", "Tired and Intimidating", "Creepy and Strong", "Respectful and Jealous", "Discreet and Secretive", "Respectful and Indiscrete", "Dumb and Dependable", "Alcoholic and Eloquent", "Curious and Conversational", "Disciplined and Shallow", "Bratty and Simple", "Dull and Humorous", "Talkative and Insincere", "Melancholy and Messy", "Dumb and Sharp", "Unforgiving and Sneaky", "Wise and Curious", "Sullen and Discerning", "Rude and Patriotic", "Disrespectful and Audacious", "Virtuous and Cheerful", "Easygoing and Frank", "Industrious and Emotional", "Tattooed and Talkative", "Forgetful and Messy", "Shrewd and Honorable", "Malicious and Sleazy", "Paranoid and Good Gambler", "Melancholy and Studious", "Thorough and Cold", "Gloomy and Tattooed", "Abrasive and Reflective", "Creepy and Good-looking", "Rude and Stutters", "Dishonest and Beautiful", "Creepy and Belligerent", "Scrawny and Ugly", "Contrarian and Graceful", "Respectful and Self-Centered", "Uncooperative and Charmer", "Clever and Scarred Face", "Macho and Cynical", "Graceful and Patriotic", "Tempermental and Unfriendly", "Scarred Face and Shy", "Bashful and Sympathetic", "Tenacious and Courteous", "Energetic and Sincere", "Insincere and Jealous", "Calm and Tactful", "Overweight and Unforgiving", "Gullible and Tempermental", "Courteous and Filthy mouth", "Logical and Likeable", "Rash and Brilliant", "Well-informed and Disciplined", "Ugly and Innocent", "Dishonest and Educated", "Strong-willed and Macho", "Intelligent and Empathic", "Ugly and Sly", "Debonair and Wary", "Quiet and Insincere", "Scarred Face and Disrespectful", "Thoughtful and Shallow", "Strong and Cynical", "Deferential and Aloof", "Solitary and Strange", "Tactful and Thrifty", "Fanatical and Story-teller", "Suave and Forgetful", "Irritating and Tenacious", "Forgetful and Logical", "Insincere and Macho", "Sweet and Honorable", "Unhappy and Sleazy", "Withdrawn and Brazen", "Reckless and Fanatical", "Strong and Loves Beer", "Fearful and Timid", "Thoughtful and Lazy", "Audacious and Determined", "Deceitful and Self-Centered", "Strong-willed and Calm", "Honest and Irritating", "Paranoid and Cynical", "Unfriendly and Poor Gambler", "Brutish and Abrasive", "Incoherent and Disrespectful", "Brainy and Tempermental", "Eloquent and Pensive", "Reluctant and Talkative", "Ugly and Quarrelsome", "Quiet and Snob", "Jealous and Patriotic", "Rugged and Brutish", "Determined and Shallow", "Bashful and Incoherent", "Timid and Debonair", "Boisterous and Silent", "Curious and Gullible", "Audacious and Lunatic", "Succinct and Touchy", "Alert and Reserved", "Intolerant and Unfriendly", "Quarrelsome and Immodest", "Timid and Loves Beer", "Tall and Clean", "Jaded and Rash", "Cowardly and Shrewd", "Conversational and Haughty", "Pleasant and Graceful", "Thorough and Humorous", "Compassionate and Unhappy", "Ignorant and Well-informed", "Shrewd and Spoiled", "Empathic and Sharp", "Self-Centered and Bashful", "Picks nose and Messy", "Focused and Rugged", "Patient and Eloquent", "Disrespectful and Considerate", "Temperate and Reflective", "Scarred Face and Immature", "Solitary and Immodest", "Sharp and Disciplined", "Brash and Know-it-all", "Good Gambler and Brutish", "Helpful and Unforgiving", "Incoherent and Belligerent", "Fearful and Ugly", "Sarcastic and Sneaky", "Cruel and Humble", "Stutters and Intimidating", "Story-teller and Creepy", "Shrewd and Creepy", "Strict and Evasive", "Determined and Condescending", "Frank and Courteous", "Brutish and Filthy mouth", "Alcoholic and Rich", "Empathic and Smooth", "Hot-headed and Cheerless", "Manipulative and Observant", "Tenacious and Selfish", "Forgetful and Cruel", "Sagely and Inventive", "Dishonest and Cultured", "Classy and Brainy", "Hot-headed and Patient", "Virtuous and Witty", "Rash and Eccentric", "Snob and Unhappy", "Careful and Superstitious", "Self-Centered and Observant", "Boastful and Good-looking", "Brazen and Sagely", "Loud and Strange", "Crabby and Flirty", "Shrewd and Nosy", "Boring and Respectful", "Malicious and Irritable", "Selfish and Strong-willed", "Argumentative and Eloquent", "Miserly and Overweight", "Overweight and Rash", "Melancholy and Classy", "Nosy and Sensitive", "Quiet and Reluctant", "Evasive and Cold", "Spoiled and Overweight", "Irritable and Messy", "Selfish and Bites Nails", "Clever and Know-it-all", "Energetic and Temperate", "Calm and Reluctant", "Reserved and Dishonest", "Snob and Determined", "Cruel and Strong", "Talkative and Opinionated", "Irritable and Con man", "Dull and Frugal", "Rude and Reliable", "Skillful and Obese", "Curious and Brilliant", "Honest and Sympathetic", "Sympathetic and Focused", "Story-teller and Wary", "Alert and irresponsible", "Sincere and Cultured", "Bossy and Dependable", "Refined and Angry", "Mature and Cold", "Sadistic and Verbose", "Cheerful and Spunky", "Reliable and Immature", "Boisterous and Shy", "Obnoxious and Sarcastic", "Haughty and Superstitious", "Bratty and Rude", "Ignorant and Touchy", "Cruel and Quarrelsome", "Reckless and Cultured", "Skillful and Tempermental", "Innocent and Indiscrete", "Belligerent and Beautiful", "Strong and Lazy", "Cheerful and Jealous", "Bashful and Pleasant", "Trustworthy and Logical", "Clever and Diligent", "Humble and Brazen", "Reluctant and Scarred Face", "Determined and Crabby", "Brainy and Observant", "Disciplined and Jaded", "Macho and Brash", "Discerning and Gloomy", "Friendly and Conversational", "Tempermental and Witty", "Silent and Verbose", "Emotional and Withdrawn", "Tired and Frugal", "Tactful and Patriotic", "Charmer and Cranky", "Superstitious and Educated", "Argumentative and Fearful", "Focused and Clever", "Quarrelsome and Discerning", "Charismatic and Sharp", "Messy and Cheerful", "Unfriendly and Dishonest", "Charismatic and Poor Gambler", "Nimble and Frank", "Bratty and Intelligent", "Strange and Bratty", "Discreet and Reckless", "Disrespectful and Obese", "Observant and Filthy mouth", "Pensive and Haughty", "Nosy and Sheepish", "Sagely and Well-informed", "Withdrawn and Considerate", "Poor Gambler and Calm", "Bashful and Patient", "Strong and Sly", "Loud and Honest", "Reserved and Skillful", "Fanatical and Jealous", "Succinct and Debonair", "Scarred Face and Know-it-all", "Debonair and Know-it-all", "Sneaky and Self-Centered", "Sleazy and Silent", "Generous and Macho", "Insincere and Charmer", "Debonair and Intolerant", "Insincere and Gullible", "Irritating and Loves Beer", "Pleasant and Rash", "Upbeat and Tenacious", "Lunatic and Overweight", "Disciplined and Spunky", "Patient and Perfectionist", "Sleazy and Fearful", "Cheerless and irresponsible", "Disagreeable and Religious", "Beautiful and Stubborn", "Obese and Emotional", "Quarrelsome and Angry", "Unfriendly and Overweight", "Rude and Overweight", "Self-Centered and Reliable", "Compassionate and Fanatical", "Shrewd and Irritable", "Stutters and Ugly", "Pensive and Picks nose", "Charmer and Good-looking", "Pleasant and Inquisitive", "Studious and Incoherent", "Pensive and Boisterous", "Disciplined and Trustworthy", "Secretive and Pleasant", "Discerning and Courteous", "Insincere and Plain", "Kleptomaniac and Selfish", "Tired and Suave", "Gullible and Strong", "Inquisitive and Introverted", "Suave and Energetic", "Strict and Crabby", "Ostentatious and Lazy", "Sadistic and Fearful", "Compassionate and Strong", "Observant and Scruffy", "Dull and Sharp", "Obese and Mature", "Alcoholic and Sullen", "Beautiful and Succinct", "Snob and Intuitive", "Vain and Sharp", "Frugal and Rugged", "Intuitive and Spoiled", "Belligerent and Thorough", "Focused and Manipulative", "Educated and Artistic",
  ]},  

  {"title": "d26 Race", "id":"dxrace", "roll":[
    "Dragonborn",
    "Dwarf",
    "Elf",
    "Gnome",
    "Gnome",
    "Half-elf",
    "half-elf",
    "Half-elf",
    "Half-elf",
    "Halfling",
    "Halfling",
    "Halfling",
    "Half-Orc",
    "Human",
    "Human",
    "Human",
    "Human",
    "Human",
    "Human",
    "Human",
    "Human",
    "Human",
    "Human",
    "Human",
    "Dragonborn",
    "Tiefling",   ]},

  {"title": "d49 Hair Color", "id":"dxhaircolor", "roll":[
    "Blonde",
    "Brown",
    "Black",
    "Brunette",
    "Auburn",
    "Dirty Blonde",
    "Strawberry Blonde",
    "Chesnut",
    "White",
    "Orange",
    "Blonde",
    "Blonde",
    "Blonde",
    "Blonde",
    "Blonde",
    "Blonde",
    "Blonde",
    "Blonde",
    "Blonde",
    "Blonde",
    "Blonde",
    "Blonde",
    "Blonde",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Black",
    "Black",
    "Black",
    "Black",
    "Black",
    "Black",
    "Black",
    "Black",
    "Black",
    "Black",
    "Black",
    "Black",
    "Black",   ]},

  {"title": "d63 Eye Color", "id":"dxeyecolor", "roll":[
    "Blue",
    "Brown",
    "Hazel",
    "Hazel",
    "Hazel",
    "Hazel",
    "Hazel",
    "Hazel",
    "Hazel",
    "Hazel",
    "Hazel",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Green",
    "Pale Green",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Blue",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    "Brown",
    ]},

  {"title": "d20 Eyes: The person has...", "id":"d20eyesthepersonhas", "roll":[
    "Sleepy eyes.",
    "Shifty eyes.",
    "Watery eyes.",
    "Bright eyes.",
    "Cold eyes.",
    "Smiling eyes.",
    "Close-set eyes.",
    "Wild eyes.",
    "Distant eyes.",
    "A lazy eye.",
    "Piercing eyes.",
    "Watchful eyes.",
    "Dark eyes.",
    "Hooded eyes.",
    "Eyes of two different colors.",
    "Slightly crossed eyes.",
    "Wide eyes.",
    "Beautiful eyes.",
    "Beady eyes.",
    "Penetrating eyes.",
    ]},
  {"title": "d12 Ears: The person has...", "id":"d12earsthepersonhas", "roll":[
    "Over-sized ears.",
    "Long ear lobes.",
    "Small ears.",
    "Uneven ears.",
    "Hairy ears.",
    "Pointy ears.",
    "Short ear lobes.",
    "Ears that stick out.",
    "Jug-handle ears.",
    "Elaborately pierced ears.",
    "Cauliflower ears.",
    "Ears with improbable tufts of hair.",
    ]},
  {"title": "d10 Mouth: The person has...", "id":"d10mouththepersonhas", "roll":[
    "Full lips.",
    "Buck-teeth.",
    "Thin lips.",
    "Rotting teeth.",
    "Crooked teeth.",
    "A broken or missing tooth.",
    "Pursed lips.",
    "Dry, cracked lips.",
    "One or more false teeth.",
    "A mouth that hangs open.",
    ]},
  {"title": "d12 Nose: The person has...", "id":"d12nosethepersonhas", "roll":[
    "A crooked nose.",
    "A bulbous nose.",
    "A narrow nose.",
    "A button nose.",
    "A long nose.",
    "A broad nose.",
    "An angular nose.",
    "A round nose.",
    "A broken nose.",
    "A hawk-like nose.",
    "A wide nose.",
    "A delicate nose.",
    ]},
  {"title": "d8 Chin or jaw: He/she has...", "id":"d8chinorjawheshehas", "roll":[
    "A pronounced chin.",
    "A cleft chin.",
    "A dimple on the chin.",
    "A rounded chin.",
    "A sharp jawline.",
    "A square jaw.",
    "A round jaw.",
    "An underbite.",
    ]},
  {"title": "d20 Hair: The person has...", "id":"d20hairthepersonhas", "roll":[
    "Thick hair.",
    "Wispy hair.",
    "Straight hair.",
    "Wavy hair.",
    "Curly hair.",
    "Wiry hair.",
    "Oily hair.",
    "Lush hair.",
    "Poofy hair.",
    "Long braids.",
    "Braids tight against the head.",
    "Very long hair.",
    "Greasy hair.",
    "Unruly hair.",
    "An unusual hairstyle.",
    "An outdated hairstyle.",
    "A high-maintenance hairstyle.",
    "Short-cropped hair.",
    "A shaved head.",
    "No hair at all.",
    ]},
  {"title": "d8 Other: His/her face has...", "id":"d8otherhisherfacehas", "roll":[
    "High cheekbones.",
    "Tight, drawn cheeks.",
    "Chubby cheeks.",
    "An unpleasant pustule.",
    "A large mole.",
    "A beauty mark.",
    "Freckles.",
    "Terrible scarring.",
    ]},
  {"title": "d6 Height: The person is...", "id":"d6heightthepersonis", "roll":[
    "Unusually short.",
    "Short in stature.",
    "Average height.",
    "Slightly above average height.",
    "Well above average height.",
    "Unusually tall.",
    ]},
  {"title": "d20 Body: The person’s body is...", "id":"d20bodythepersonsbodyis", "roll":[
    "Thin and delicate.",
    "Of average build.",
    "Well-muscled.",
    "Slightly overweight.",
    "Grotesquely obese.",
    "Lean and lanky.",
    "Lithe and lean.",
    "Thin and wiry.",
    "Sinewy and strong.",
    "Flabby and weak.",
    "Lumpy or bent.",
    "Thin and flimsy.",
    "Soft and chubby.",
    "Thin and petite.",
    "Pudgy.",
    "Big and broad.",
    "Stocky and strong.",
    "Bony.",
    "Wide and ponderous.",
    "Covered in hair.",
    ]},
  {"title": "d6 Hands: The person has...", "id":"d6handsthepersonhas", "roll":[
    "Powerful hands.",
    "Delicate hands.",
    "Rough hands.",
    "Soft hands.",
    "A light touch.",
    "A heavy touch.",
    ]},
  {"title": "d8 Scar: The person has...", "id":"d8scarthepersonhas", "roll":[
    "A jagged scar.",
    "A dark purple scar.",
    "An angry red scar.",
    "A long, thin scar.",
    "No Scar",
    "No Scar",
    "No Scar",
    "No Scar",
    ]},
  {"title": "d12 Tattoo: The person has...", "id":"d12tattoothepersonhas", "roll":[
    "A dagger tattoo.",
    "An arrow tattoo.",
    "An anchor tattoo.",
    "A skull tattoo.",
    "A pair of crossed bones tattoo.",
    "A snake tattoo.",
    "A scorpion tattoo.",
    "A spider web tattoo.",
    "A heart tattoo.",
    "A ring of thorns tattoo.",
    "A mermaid tattoo.",
    "A dragon tattoo.",
    ]},
  {"title": "d12 Jewelry: The person wears...", "id":"d12jewelrythepersonwears", "roll":[
    "An earring.",
    "Two earrings.",
    "A small chain about the neck.",
    "A large chain about the neck.",
    "A tight choker about the neck.",
    "A brooch.",
    "A ring.",
    "Several rings.",
    "A bracelet.",
    "A nose ring.",
    "A medallion.",
    "An ornate belt.",
    ]},
  {"title": "d8 The jewelry is made of…", "id":"d8thejewelryismadeof", "roll":[
    "Steel.",
    "Bronze.",
    "Pewter.",
    "Silver.",
    "Gold.",
    "Platinum.",
    "Copper.",
    "One or more gemstones (d10): 1. diamond; 2. emerald; 3. jade; 4. obsidian; 5. opal; 6. pearl; 7. ruby; 8. sapphire; 9. topaz; 10. turquoise.",
    ]},
  {"title": "d8 Clothes: The person’s clothing is...", "id":"d8clothesthepersonsclothingis", "roll":[
    "Crisp and new.",
    "Fashionable and hip.",
    "A bit old-fashioned.",
    "Of the highest quality.",
    "Faded, but in good condition.",
    "Faded and patched.",
    "Torn in places; missing buttons.",
    "Tattered and worn.",
    ]},
  {"title": "d32 Calm Trait: When calm, the person is typically...", "id":"d32calmtraitwhencalmthepersonistypically", "roll":[
    "Compassionate",
    "Cheerful",
    "Reserved",
    "Outspoken",
    "Uninterested",
    "Gruff",
    "Eager",
    "Deceitful",
    "Foolish",
    "Strict",
    "Agreeable",
    "Mischievous",
    "Angry",
    "Fearful",
    "Manipulative",
    "Devout",
    "Greedy",
    "Funny",
    "Dour",
    "Fun-Loving",
    "Lazy",
    "Driven",
    "Boastful",
    "Artistic",
    "Assertive",
    "Carefree",
    "Cautious",
    "Confident",
    "Thoughtful",
    "Loyal",
    "Sophisticated",
    "Weak-Willed",
    ]},
  {"title": "d32 Stress Trait: When stressed, the person often becomes...", "id":"d32stresstraitwhenstressedthepersonoftenbecomes", "roll":[
    "Withdrawn",
    "Murderous",
    "Obsessive",
    "Authoritarian",
    "Determined",
    "Brave",
    "Spiteful",
    "Belligerent",
    "Caustic",
    "Reckless",
    "Argumentative",
    "Gluttonous",
    "Overly Protective",
    "Angry",
    "Cowardly",
    "Meticulous",
    "Sarcastic",
    "Stubborn",
    "Destructive",
    "Practical",
    "Pushy",
    "Fanatical",
    "Secretive",
    "Scornful",
    "Courageous",
    "Impractical",
    "Calculating",
    "Industrious",
    "Manipulative",
    "Destructive",
    "Compulsive",
    "Intolerant",
    ]},
  {"title": "d20 Mood: Now, the person is...", "id":"d20moodnowthepersonis", "roll":[
    "Agreeable.",
    "Carefree.",
    "Curious.",
    "Eager.",
    "Friendly.",
    "Happy.",
    "Hopeful.",
    "Upbeat.",
    "Indifferent.",
    "Bored.",
    "Focused.",
    "Suspicious.",
    "Tired.",
    "Withdrawn.",
    "Disagreeable.",
    "Agitated.",
    "Angry.",
    "Despondent.",
    "Gloomy.",
    "Nervous.",
    ]},
  {"title": "d8 The person is a...", "id":"d8thepersonisa", "roll":[
    "Quiet true believer.",
    "Casual observer.",
    "Critical student.",
    "Outspoken cynic.",
    "Open-minded seeker.",
    "Broken heretic.",
    "Cautious listener.",
    "Fanatical true believer.",
    ]},
  {"title": "d6 The person is prejudice against...", "id":"d6thepersonisprejudiceagainst", "roll":[
    "Other genders.",
    "An age group (d3): 1. children; 2. teenagers; 3. elderly.",
    "A social class (d3): 1. ruling class and authority figures; 2. powerful rich; 3. destitute poor.",
    "Social deviants (d3): 1. beggars; 2. drunks; 3. drug-users.",
    "A profession (d12): 1. farmers; 2. artists; 3. clergy; 4. soldiers; 5. fishers; 6. harlots; 7. miners; 8. merchants; 9. scholars; 10. herders; 11. sailors; 12. mages",
    "A race (d8): 1. dwarves; 2. elves; 3. gnomes;; 4. goblins; 5. half-breeds; 5. halflings; 6. humans; 7. orcs; 8. reptilians.",
    ]},
  {"title": "d20 Flaws: The person...", "id":"d20flawstheperson", "roll":[
    "Fidgets.",
    "Drinks too much.",
    "Eats too much.",
    "Swears often.",
    "Has poor hygiene.",
    "Can’t resist flirting.",
    "Can’t stop staring.",
    "Sweats profusely and easily.",
    "Is a habitual liar.",
    "Embellishes the truth.",
    "Exaggerates details.",
    "Has a short temper.",
    "Is melodramatic.",
    "Gossips.",
    "Chews with an open mouth.",
    "Often sniffs audibly.",
    "Believes what you tell him/her.",
    "Is skeptical of everything.",
    "Paces.",
    "Makes poor eye contact.",
    ]},
  {"title": "D8 AGE X is", "id":"d8agexis", "roll":[
    "a barely teenaged",
    "a young adult",
    "an adult",
    "a middleaged",
    "an older",
    "an ancient",
    "more dead than living",
    "non-aging",
    ]},
  {"title": "D4 SEX", "id":"d4sex", "roll":[
    "woman",
    "man",
    "person whose sex is hard to tell",
    "creature",
    ]},
  {"title": "D8 HAIRTYPE with", "id":"d8hairtypewith", "roll":[
    "greasy",
    "healthy",
    "neat",
    "spotty",
    "thin",
    "thick",
    "curly",
    "seemingly living",
    ]},
  {"title": "D8 HAIRCOLOR", "id":"d8haircolor", "roll":[
    "white, almost glowing",
    "grey",
    "black",
    "dark brown",
    "light brown",
    "blonde",
    "platinum blonde",
    "red",
    ]},
  {"title": "D12 HAIRSTYLE", "id":"d12hairstyle", "roll":[
    "and extraordinarily long hair reaching all the way down the back",
    "shoulder long hair",
    "long hair",
    "long hair done up in a bun",
    "long hair done up in a ponytail",
    "long braided hair",
    "long hair with strange objects braided into it",
    "long completely tangled and matted hair",
    "long completely tangled and matted hair with strange objects attached",
    "short hair",
    "stubs after having been shaved off just recently",
    "lost long ago to baldness",
    ]},
  {"title": "D24 MARK (1d6d6) and", "id":"d24mark1d6d6and", "roll":[
    "an eye patch",
    "a lazy eye",
    "a glass eye",
    "greasy glasses",
    "glasses",
    "a blindfold over the eyes",
    "a hat",
    "the remnants of a hat",
    "a mouth without teeth",
    "a mouth filled with gold teeth",
    "an alluring smile",
    "a great scar",
    "a sad look",
    "a constant grin",
    "a quiet demeanor",
    "eyes staring straight into your soul",
    "a mutilated face",
    "a deformed face",
    "a pointy nose",
    "the nose cut off",
    "an obscure symbol branded on the neck",
    "an otherwise extraordinarily ordinary appearance",
    "a very long tongue",
    "a terrifying libido",
    ]},
  {"title": "D10 HOME who's living", "id":"d10homewhosliving", "roll":[
    "in a small apartment (D4): 1. on top of a small shop; 2. in an immense apartment building; 3. in a damp tenement; 4. in a moldy boarding house;",
    "in a shack (D4): 1. build of garbage; 2. in a public park; 3. under a bridge; 4. up in a tree;",
    "in an inherited (D4): 1. villa; 2. estate; 3. townhouse; 4. carriage;",
    "in a small townhouse (D4): 1. with boarded up windows; 2. with heavy curtains covering the windows; 3. with a wilderness for a garden; 4. without any windows at all;",
    "in a burned down (D4): 1. warehouse; 2. villa; 3. church; 4. workshop;",
    "in an abandoned overgrown (D4): 1. warehouse; 2. villa; 3. church; 4. workshop;",
    "in a tent (D4): 1. in a public park; 2. on a graveyard; 3. under a bridge; 4. in someone else’s garden;",
    "in a grand (D4): 1. estate; 2. villa; 3. apartment; 4. mansion;",
    "in the basement (D4): 1. of an abandoned hospital; 2. of a workshop; 3. of someone else’s house; 4. of a sketchy tavern",
    "in a supposedly enchanted (D4): 1. closet; 2. shed; 3. tree-house; 4. hole in the wall;",
    ]},
  {"title": "D10 LOCATION", "id":"d10location", "roll":[
    "somewhere in town",
    "somewhere outside of town",
    "somewhere in the nice part of town",
    "somewhere in the slums",
    "on the streets, for some reason.",
    "… Beneath the city?",
    "in a cave",
    "somewhere we’ve all suppressed from our memories.",
    "in an otherwise desolate part of town",
    "near the waterfront",
    ]},
  {"title": "D10 OCCUPATION X is", "id":"d10occupationxis", "roll":[
    "an archivist (D4): 1. with an interest for the hideous; 2. with a large collection of obscure trinkets; 3. organizing the strange collection of the local museum; 4. who collects very particular books;",
    "a priest (D4): 1. with little interest in his flock; 2. who’s slowly but steadily deviating from the pious path; 3. who lives in seclusion; 4. with a veiled interest in the obscure;",
    "a collector (D8): 1. of peculiar stones; 2. of primordial artifacts; 3. of cats; 4. of obscure art; 5. of ancient books; 6. of old diaries; 7. of crime memorabilia; 8. of toys;",
    "an adventurer (D4): 1. who’s only ever seen leaving home at night; 2. with a staggering hatred for the undead; 3. who’s constantly preparing for the apocalypse; 4. who’s always just getting wasted alone",
    "a doctor (D4): 1. with dubious credentials; 2. who’s working on an alternative treatment for a rare malady; 3. who’s obsessed with immortality; 4. who’s offering treatment to everyone, whether healthy or ill;",
    "a known thief (D4): 1. who allegedly has buried the past; 2. who’s always on the lookout for someone… Or something; 3. who’s getting by selling strange otherworldly goods in an alley; 4. who’s only ever stealing from the same person;",
    "a prostitute (D4): 1. always providing for the same mysterious customer; 2. who’s always stumbling around in the streets at night; 3. who’s always seen crying; 4. who always gently takes the hand of a PC and starts growling;",
    "a blacksmith (D4): 1. who’s always making nails; 2. who’s making iron masks of customers faces; 3. with an affection for toys and dolls; 4. who’s always make the same small figurines;",
    "a guard (D4): 1. who enjoys humiliating civilians; 2. with a worrying love for power; 3. who’s only talking to the towns kids and animals; 4. with a clear disdain for a local religious order;",
    "a merchant (D4): 1. dealing in very cheap meats; 2. and alleged grave robber; 3. providing a strange assortment of quality products incredibly cheap; 4. whose worryingly old products never seem to be exchanged;",
    ]},
  {"title": "D10 RENOWN people in town", "id":"d10renownpeopleintown", "roll":[
    "love X",
    "hate X",
    "fear X",
    "adore X",
    "worship X",
    "tolerate X",
    "barely recognizes X",
    "has forgotten about X",
    ]},
  {"title": "D10 BUILD X is", "id":"d10buildxis", "roll":[
    "fat and round",
    "built like horse",
    "of athletic stature",
    "muscular and strong",
    "scrawny",
    "physically mostly reminiscent of a curled up dry carrot",
    "tall and lanky",
    "a midget",
    "easily confused with a giant",
    "looking more dead than alive",
    ]},
  {"title": "D20 DESCRIPTOR A characteristic feature of X is", "id":"d20descriptoracharacteristicfeatureofxis", "roll":[
    "the cane",
    "the strange jumpy walk",
    "the beautiful clothes",
    "the disgusting clothes",
    "the weird objects hanging from the belt",
    "the singing",
    "the constant tears",
    "the dancing",
    "the heavy drinking",
    "the bird on the shoulder",
    "the marks on the wrists left by handcuffs",
    "the whispering",
    "the constant blinking",
    "the constant head scratching",
    "the bleeding wounds",
    "the bandages",
    "the affection for fire",
    "the pale skin",
    "the dog",
    "the cat",
    ]},
  {"title": "D8 SPEECH X talks", "id":"d8speechxtalks", "roll":[
    "with a lisp",
    "with a deep voice",
    "with a dry hoarse voice",
    "with a light squeaking voice",
    "with a soft pleasant voice",
    "with a seductive voice",
    "in a strange tongue",
    "with a sleazy voice",
    ]},
  {"title": "D20 MOTIVE All X really wants is to", "id":"d20motiveallxreallywantsisto", "roll":[
    "keep the secret",
    "runaway and hide",
    "survive",
    "taste it once again",
    "never see it again",
    "brand him with a hot iron",
    "set it all on fire and start over",
    "answer the voices",
    "honor her trust",
    "keep the promise",
    "find it",
    "hide it",
    "destroy it",
    "impress him",
    "impress her",
    "built the construction from the perpetual dreams",
    "get revenge",
    "prepare for the inevitable",
    "make it come alive",
    "to finally ascend as promised",
    ]},

];
